import React, { createContext, useContext, useEffect } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [darkMode, setDarkMode] = useLocalStorage("marinadz_darkmode", false);

  useEffect(() => {
    const html = document.documentElement;
    
    if (darkMode) {
      html.setAttribute("data-theme", "dark");
      html.style.colorScheme = "dark";
      document.body.style.backgroundColor = "#0f172a";
      document.body.style.color = "#f1f5f9";
      
      // Variables CSS
      html.style.setProperty("--bg-primary",     "#0f172a");
      html.style.setProperty("--bg-secondary",   "#1e293b");
      html.style.setProperty("--bg-card",        "#1e293b");
      html.style.setProperty("--bg-hover",       "#334155");
      html.style.setProperty("--border-color",   "#334155");
      html.style.setProperty("--text-primary",   "#f1f5f9");
      html.style.setProperty("--text-secondary", "#94a3b8");
      html.style.setProperty("--text-muted",     "#64748b");
      html.style.setProperty("--shadow",         "0 1px 3px rgba(0,0,0,0.4)");
    } else {
      html.setAttribute("data-theme", "light");
      html.style.colorScheme = "light";
      document.body.style.backgroundColor = "#f9fafb";
      document.body.style.color = "#1f2937";
      
      html.style.setProperty("--bg-primary",     "#f9fafb");
      html.style.setProperty("--bg-secondary",   "#ffffff");
      html.style.setProperty("--bg-card",        "#ffffff");
      html.style.setProperty("--bg-hover",       "#f3f4f6");
      html.style.setProperty("--border-color",   "#e5e7eb");
      html.style.setProperty("--text-primary",   "#1f2937");
      html.style.setProperty("--text-secondary", "#6b7280");
      html.style.setProperty("--text-muted",     "#9ca3af");
      html.style.setProperty("--shadow",         "0 1px 3px rgba(0,0,0,0.08)");
    }
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode(v => !v);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);